import { useSelector } from 'react-redux'

import styles from '../../search.module.scss'
import { FilterDropdown } from '@/components/search/FilterDropdown'
import { Checkbox } from '@/components/search/inputs/Checkbox'
import { filterLabelPrettyName, filterClassName } from '@/lib/utilities/search'
import {
  selectAvailableFilters,
  selectSearchParametersFilterByParameter,
} from '@/store/selectors/search'
import { SelectComponentProps } from '@/types/search'
import { isProd } from '@/lib/utilities/system'

export const AvailableMultiSelect = ({
  filter,
  toggleFilter,
  onChange,
  isFilterOpen,
  title,
  hasAbbreviatedLabels = false,
}: SelectComponentProps) => {
  const current = useSelector(state => selectSearchParametersFilterByParameter(state, filter))
  const availableOptions = useSelector(selectAvailableFilters)[filter]

  return (
    <FilterDropdown
      title={title}
      toggleFilter={toggleFilter}
      isFilterOpen={isFilterOpen}
      maximumNumberOfVisibleSelectedOptions={3}
      hasSelectedOptions={current.length > 0}
      selectedOptions={
        current.length > 0
          ? [...current]
            .sort((a, b) => a - b)
            .map(i => filterLabelPrettyName(filter, i, undefined, hasAbbreviatedLabels))
          : ['All']
      }>
      {availableOptions.length > 0 ? (
        <div className={styles['multi-select']}>
          {availableOptions.map((i: { id: number; name: string }) => (
            <Checkbox
              filter={filter}
              isSelected={current.includes(i.id)}
              valueAttribute="id"
              onChange={onChange}
              key={i.id}
              item={i}
              className={!isProd() ? `search__${filter}-button search__${filter}-button-${filterClassName(filterLabelPrettyName(filter, i.name))}` : ''}
            />
          ))}
        </div>
      ) : (
        <p className={styles['error-text']}>
          {`There are no "${title}" options available based on your current filter selections`}
        </p>
      )}
    </FilterDropdown>
  )
}
